import React from 'react'

const Footer = () => {
  return (
    <div className='flex items-center justify-center bg-mutani h-14 w-full px-8 text-white'>
        <p className='flex justify-center items-center text-center text-sm text-white font-light leading-relaxed'>@Mutani 2022 | Terma & Conditions | Data Processing | Privacy | Speak to Sales</p>
    </div>  )
}

export default Footer